import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import ApiStore from '../../api/ApiStore';

const PracticeSetup = ({ onSetupComplete, store }) => {
  const [licenseType, setLicenseType] = useState('permiso_b');
  const [pomodoroTime, setPomodoroTime] = useState(25);
  const [restingTime, setRestingTime] = useState(5);
  const [soundsEnabled, setSoundsEnabled] = useState(true);

  const handleStartPractice = async () => {
    try {
      // Fetch the current level before starting practice
      const organizationName = store.profile.organization;
      const levelInfo = await ApiStore.evaluateLevelAuto(
        licenseType,
        organizationName
      );

      // levelInfo should contain current_level and completion_percentage
      const { current_level, completion_percentage } = levelInfo;

      onSetupComplete({
        licenseType,
        pomodoroTime,
        restingTime,
        currentLevel: current_level,
        completionPercentage: completion_percentage,
        soundsEnabled,
      });
    } catch (error) {
      console.error('Error initializing level info:', error);
      // Handle error (e.g., show a message to the user)
      onSetupComplete({
        licenseType,
        pomodoroTime,
        restingTime,
        soundsEnabled,
      });
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        Configurar sesión de estudio
      </h2>
      <div className="space-y-6">
        <div>
          <label
            className="block text-gray-700 text-sm font-medium mb-2"
            htmlFor="pomodoroTime"
          >
            Tiempo de Trabajo (minutos)
          </label>
          <input
            id="pomodoroTime"
            type="number"
            min="1"
            max="120"
            value={pomodoroTime}
            onChange={e => setPomodoroTime(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            className="block text-gray-700 text-sm font-medium mb-2"
            htmlFor="restingTime"
          >
            Tiempo de Descanso (minutos)
          </label>
          <input
            id="restingTime"
            type="number"
            min="1"
            max="60"
            value={restingTime}
            onChange={e => setRestingTime(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="flex items-center justify-between">
          <label className="text-gray-700 text-sm font-medium">
            Sonidos de recompensa
          </label>
          <div className="relative inline-block w-12 mr-2 align-middle select-none transition duration-200">
            <input
              type="checkbox"
              name="toggle"
              id="sounds-toggle"
              checked={soundsEnabled}
              onChange={() => setSoundsEnabled(!soundsEnabled)}
              className="sr-only"
            />
            <label
              htmlFor="sounds-toggle"
              className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors duration-300 ${soundsEnabled ? 'bg-blue-500' : 'bg-gray-300'}`}
            >
              <span
                className={`block w-6 h-6 rounded-full bg-white shadow transform transition-transform duration-300 ${soundsEnabled ? 'translate-x-6' : 'translate-x-0'}`}
              ></span>
            </label>
          </div>
        </div>
        <button
          onClick={handleStartPractice}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300"
        >
          Empezar práctica
        </button>
      </div>
    </div>
  );
};

export default inject('store')(observer(PracticeSetup));
